// extracted by mini-css-extract-plugin
var _1 = "RequestMultiValuedListMoreItem-modulearchivedIconContainer__ZCPnI EntityArchivedIcon-moduleentityArchivedIconContainer__u1fL2 IconNG-moduleiconContainer__SxWZ0";
var _2 = "RequestMultiValuedListMoreItem-moduleicon__CMLCm";
var _3 = "RequestMultiValuedListMoreItem-moduleinfo__qsnwR";
var _4 = "RequestMultiValuedListMoreItem-moduleitem__B_8vx";
var _5 = "RequestMultiValuedListMoreItem-modulemoreItem__lksEv MultiValuedListMoreItem-moduleMultiValuedListMoreItem__SSTEE";
var _6 = "RequestMultiValuedListMoreItem-moduleremoveButton__m4WxI";
var _7 = "RequestMultiValuedListMoreItem-moduletext__u9_pq";
export { _1 as "archivedIconContainer", _2 as "icon", _3 as "info", _4 as "item", _5 as "moreItem", _6 as "removeButton", _7 as "text" }
